module.exports = __webpack_public_path__ + "img/guide01.c1b990d6.png";